// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1hTFlK7M13ZRY1dMfZrhKc","Content":"_3NzBF6d9ViuePcxjpsrSjo","Title":"_3v4mUTlPxRXv7Jd15ibFoR","Grid":"_3fHms6V_lZQnEQlq69efkF","Item":"_2azSyw6ZVvGURz5KbGLOHI","Label":"_3FAXm2Ile7YaLagptozCjI","Value":"MlQ8VWBUDcHsqnsIWzPV1","Footer":"_1iR-gqnknutXzZqOcGi3jk","Error":"_1rQx63Ucb4zwLsUQlbyhaw","Success":"_2CV_jTOrKYxKsgac39g7lH"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PayControls/styles.module.css
// module id = 559
// module chunks = 0